module.exports = __webpack_public_path__ + "img/QR_code.dd056ec2.png";